// Single source of truth for the hosts this app will treat as its own.
// Used to validate login/logout return URLs and any redirect target supplied
// via URL. Anything not listed here is refused — no wildcards, no suffix match.
export const APPROVED_ORIGINS = new Set([
  'https://trinitydentalarts.com',
  'https://www.trinitydentalarts.com',
  'https://trinity-dental-smile.base44.app',
]);

// Local development only; never reachable in a deployed build.
const DEV_ORIGINS = new Set([
  'http://localhost:3000',
  'http://127.0.0.1:3000',
  'http://localhost:5173',
  'http://127.0.0.1:5173',
]);

// Accepts a full URL or a path. Paths resolve against the live site origin.
export function isApprovedOrigin(value) {
  if (typeof value !== 'string' || !value) return false;
  try {
    const url = new URL(value, 'https://trinitydentalarts.com');
    if (url.protocol !== 'https:' && !DEV_ORIGINS.has(url.origin)) return false;
    return APPROVED_ORIGINS.has(url.origin) || DEV_ORIGINS.has(url.origin);
  } catch {
    return false;
  }
}

// Returns `value` when it points at an approved host, otherwise `fallback`.
export function safeReturnUrl(value, fallback = '/') {
  return isApprovedOrigin(value) ? value : fallback;
}